<script setup lang="ts">
const route = useRoute()
const { contributors } = useProductContributors()
const { activeProduct } = useProductVariantsStore()
const { activeArticle, activeSubject } = useProductContentStore()
const site = useSiteConfig()

const isCitationOpen = ref(false)

const formattedAuthors = computed(() => formatAuthors(contributors.value))
</script>

<template>
  <section class="relative pb-4 font-national2">
    <h2 class="sr-only">
      Sitering
    </h2>
    <details
      class="p-1 py-2 md:py-4 "
      :open="isCitationOpen"
      @toggle="isCitationOpen = !isCitationOpen"
    >
      <summary
        class="flex cursor-pointer items-center gap-2 py-1 font-medium md:text-lg"
      >
        <span class="text-base font-extrabold md:text-lg">Sitere eller gjenbruke?</span>
        <UIcon
          :name="isCitationOpen ? 'chevron-up' : 'chevron-down'"
          size="md"
        />
      </summary>
      <div class="pt-4">
        <p class="rounded-lg bg-white p-4 text-base text-platform-black md:text-lg">
          <span v-if="formattedAuthors">{{ formattedAuthors }}&nbsp;</span>
          <span v-else>Universitetsforlaget, Aschehougs akademiske forlag.&nbsp;</span>
          <span><i v-if="activeArticle?.title"> {{ activeArticle.title }}.&nbsp;</i></span>
          <span v-if="activeProduct?.productTitle">Kunne&nbsp;{{ activeProduct?.productTitle }}.&nbsp;</span>
          <span v-if="activeSubject?.modified">Sist oppdatert: <NuxtTime
            :datetime="activeSubject.modified"
            date-style="long"
            locale="nb-NO"
          />. </span>
          <span class="break-all">{{ site.url }}{{ route.fullPath }}</span>
        </p>
      </div>
    </details>
  </section>
</template>

<style scoped lang="postcss">
details {
  overflow: hidden;
}

details::details-content {
  transition:
    block-size 0.5s ease,
    content-visibility 0.5s;
  transition-behavior: allow-discrete;
  block-size: 0;
}

details[open]::details-content {
  block-size: auto;
}
</style>
